import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSiteLocales = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSiteLocales(state);
};

export default getSiteLocales;
